import { z } from 'my-zod'
import { damageWaiverCaseModel } from './damage-waiver-case-model'
import { partsOrderModel } from './parts-order/parts-order-model'
import { involvedPartyModel } from './involved-parties/involved-party-model'

export const damageWaiverCaseSystemView = damageWaiverCaseModel.augment({
  involvedParties: involvedPartyModel.array(),
  partsOrders: partsOrderModel.array()
})

export type damageWaiverCaseSystemView = z.infer<typeof damageWaiverCaseSystemView>
